module.exports = __webpack_public_path__ + "img/mrppt.7e245e86.png";